import { CountyService } from './../../shared/county.service';
import { Component, OnInit, Input } from '@angular/core';
import { Bondsman } from '../bondsman';
import { IMultiSelectOption } from 'angular-2-dropdown-multiselect';
import { Router } from '@angular/router';
import { FileNumberUtil } from '../../shared/file-number-util';

@Component({
  selector: 'app-licensee-status',
  templateUrl: './licensee-status.component.html',
  styleUrls: ['./../../case-view/civil/civil-case-view.component.less']
})
export class LicenseeStatusComponent implements OnInit {

  @Input() bondsman: Bondsman;
  @Input() isRequestForStatusInFlight: boolean;

  constructor(private router: Router) {
  }

  ngOnInit() {
  }

  onViewLicenseNumberSelected(licenseNumber: string, stateLicenseNumber: string): void {
    this.router.navigate(
      [{
        outlets: {
          view: ['bondsman', licenseNumber, stateLicenseNumber]
        }
      }]);
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/bondsman/licensee-status/licensee-status.component.ts